export const getBizEntityUrl = (subUrl: string, isRegex = false) => {
  if (isRegex) {
    return new RegExp(`/api-proxy/api/(?:[^/]+/)?bizEntity/${subUrl}`);
  }
  return `/api-proxy/api/**/bizEntity/${subUrl}`;
};
